export interface ListResult<T> {
  rows: T[];
  next_cursor_created_at: string | null;
  next_cursor_id: string | null;
}

/** Reject a broken server contract rather than displaying a false empty list. */
export function parseListResult<T>(value: unknown): ListResult<T> {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    throw new Error("The list could not be read. Please retry.");
  }
  const result = value as Record<string, unknown>;
  const validCursor = (v: unknown) => v === null || typeof v === "string";
  if (!Array.isArray(result.rows) || !validCursor(result.next_cursor_created_at) ||
      !validCursor(result.next_cursor_id) ||
      Boolean(result.next_cursor_created_at) !== Boolean(result.next_cursor_id)) {
    throw new Error("The list returned an incomplete response. Please retry.");
  }
  return result as unknown as ListResult<T>;
}
